import {AfterViewInit, Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Subject} from 'rxjs';
import {NgbModal, NgbModalConfig} from "@ng-bootstrap/ng-bootstrap";

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	providers: [NgbModalConfig, NgbModal]
})
export class AppComponent implements OnInit, AfterViewInit {

	lang = new Subject<string>();
	title = 'dashboard-app';

	constructor(private translate: TranslateService,
	            private ngbModalConfig: NgbModalConfig) {
		this.setUpNGBConfigs()
	}


	ngOnInit(): void {
	}

	ngAfterViewInit(): void {
	}

	private setUpNGBConfigs() {
		this.ngbModalConfig.scrollable = true;
	}

}
